import {
  Component,
  Input,
  OnInit,
} from "@angular/core";
import { NGXLogger } from "ngx-logger";
import { ConfirmationService } from "primeng/api";


import {
  DialogService,
  DynamicDialogRef,
} from "primeng/dynamicdialog";

import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-loading",
  templateUrl: "./loading.component.html",
  styleUrls: ["./loading.component.css"],
  providers: [DialogService, ConfirmationService],
})
export class LoadingComponent implements OnInit {
  @Input() contesto: string = null;

  protected isLoadingResults = false;
  ref: DynamicDialogRef;
  
  protected lottieConfig: object;
  private anim: any;


  constructor(
    private logger: NGXLogger,
   
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    
  }

  ngOnInit(): void {
    let path:string='/assets/animations/spinner.json';
    if(this.contesto && (this.contesto ==='DASHBOARD' || this.contesto ==='OVERALL')){
      //console.log('[APP LOADING] ON INIT CONTESTO ',this.contesto);
      path = '/assets/animations/spinner_dashboard.json';
    }
    this.lottieConfig = {
      path: path, 
      autoplay: true,
      loop: true,
      renderer: 'canvas',
    };

  }

  animationCreated(animation: any): void {
    this.anim = animation;
  }


}

